module.exports = __webpack_public_path__ + "Best_Education_Brand_2018-8ffd3a56.webp";